import type { StateCreator } from 'zustand';

import type { DemoSessionConfig } from '../../components/demo/types';
import type { AppSlice, GlobalStore } from '../schema';

const IS_STAGING = 'isStaging';
const DEMO_SESSION = 'demoSession';

const readDemoSession = (): DemoSessionConfig | null => {
  try {
    const raw = sessionStorage.getItem(DEMO_SESSION);
    return raw ? (JSON.parse(raw) as DemoSessionConfig) : null;
  } catch {
    return null;
  }
};

export const createAppSlice: StateCreator<
  GlobalStore,
  [['zustand/devtools', never]],
  [],
  AppSlice
> = (set) => ({
  isStaging: localStorage.getItem(IS_STAGING) === 'true',
  setIsStaging: (isStaging) => {
    localStorage.setItem(IS_STAGING, `${isStaging}`);
    set({ isStaging }, false, 'app/setIsStaging');
  },
  demoSession: readDemoSession(),
  setDemoSession: (session) => {
    if (session) sessionStorage.setItem(DEMO_SESSION, JSON.stringify(session));
    else sessionStorage.removeItem(DEMO_SESSION);
    set({ demoSession: session }, false, 'app/setDemoSession');
  },
});
